import { CL505_WITHOUT_ZIP_COUNTRIES } from 'shared/ncts/common/constants'
import { COUNTRY_CODE_PREFIX, removePrefix } from 'shared/ncts/common/classifier-util'
import { RuleResult } from '../../../../types/DeclarationP5'

const C0506Validator = {
  validateStandardPostcodeRequirement: (country?: string | null): RuleResult => {
    const countryCode = removePrefix(country, COUNTRY_CODE_PREFIX) ?? ''
    return CL505_WITHOUT_ZIP_COUNTRIES.includes(countryCode) ? 'OPTIONAL' : 'REQUIRED'
  },
  validateSecurityPostcodeRequirement: ({
    security,
    country,
  } : {
    security: string
    country?: string | null
  }): RuleResult => {
    if (!['1', '3'].includes(security)) return 'OPTIONAL'

    const countryCode = removePrefix(country, COUNTRY_CODE_PREFIX) ?? ''
    return CL505_WITHOUT_ZIP_COUNTRIES.includes(countryCode) ? 'OPTIONAL' : 'REQUIRED'
  },
}

export default C0506Validator
